/**
 * Extracts duration (in seconds) from a video File using a temporary <video> element.
 * Returns 0 as fallback if the file cannot be read or duration is unavailable.
 */
export default function extractVideoDuration(file) {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement('video');
    video.preload = 'metadata';

    const cleanup = () => {
      URL.revokeObjectURL(url);
      video.removeAttribute('src');
      video.load();
    };

    video.onloadedmetadata = () => {
      const duration =
        Number.isFinite(video.duration) && video.duration > 0
          ? Math.round(video.duration)
          : 0;
      cleanup();
      resolve(duration);
    };

    video.onerror = () => {
      cleanup();
      resolve(0);
    };

    video.src = url;
  });
}
